export const StockManagementIcon = (props: { width?: string; height?: string; fill?: string }) => {
  const { width = "24px", height = "24px", fill = "#5C5F62" } = props;

  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      width={width}
      height={height}
    >
      <g>
        <g>
          <path fill={fill} d="M7.862 13.655H3.724v-3.612a0.525 0.525 0 0 1 0.526 -0.526h3.087a0.525 0.525 0 0 1 0.526 0.526z" />
          <path
            fill={fill}
            d="M14.069 13.655h-4.138v-3.612a0.525 0.525 0 0 1 0.526 -0.526h3.087a0.525 0.525 0 0 1 0.526 0.526z"
          />
          <path
            fill={fill}
            d="M20.276 13.655h-4.138v-3.612a0.525 0.525 0 0 1 0.526 -0.526h3.087a0.525 0.525 0 0 1 0.526 0.526z"
          />
          <path fill={fill} d="M7.862 21.517H3.724V17.905a0.525 0.525 0 0 1 0.526 -0.526h3.087a0.525 0.525 0 0 1 0.526 0.526z" />
          <path
            fill={fill}
            d="M14.069 21.517h-4.138V17.905a0.525 0.525 0 0 1 0.526 -0.526h3.087a0.525 0.525 0 0 1 0.526 0.526z"
          />
          <path
            fill={fill}
            d="M20.276 21.517h-4.138V17.905a0.525 0.525 0 0 1 0.526 -0.526h3.087a0.525 0.525 0 0 1 0.526 0.526z"
          />
          <path fill={fill} d="M7.862 5.793H3.724V2.181A0.525 0.525 0 0 1 4.25 1.655h3.087a0.525 0.525 0 0 1 0.526 0.526z" />
          <path fill={fill} d="M14.069 5.793h-4.138V2.181a0.525 0.525 0 0 1 0.526 -0.526h3.087a0.525 0.525 0 0 1 0.526 0.526z" />
          <path fill={fill} d="M20.276 5.793h-4.138V2.181a0.525 0.525 0 0 1 0.526 -0.526h3.087a0.525 0.525 0 0 1 0.526 0.526z" />
        </g>
        <g>
          <path
            fill={fill}
            points="35.309,132.414 476.689,132.414 476.689,114.759 35.309,114.759 		"
            d="M1.655 6.207L22.345 6.207L22.345 5.379L1.655 5.379Z"
          />
          <path
            fill={fill}
            points="35.309,300.138 476.689,300.138 476.689,282.483 35.309,282.483 		"
            d="M1.655 14.069L22.345 14.069L22.345 13.241L1.655 13.241Z"
          />
          <path
            fill={fill}
            points="35.309,467.862 476.689,467.862 476.689,450.207 35.309,450.207 		"
            d="M1.655 21.931L22.345 21.931L22.345 21.103L1.655 21.103Z"
          />
        </g>
        <g>
          <path fill={fill} d="M1.655 24H0V0.828C0 0.37 0.37 0 0.828 0S1.655 0.37 1.655 0.828z" />
          <path fill={fill} d="M24 24h-1.655V0.828C22.345 0.37 22.715 0 23.172 0S24 0.37 24 0.828z" />
        </g>
      </g>
    </svg>
  );
};
